import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const countVars = (t) => {
    const body = (t.components || []).find((c) => c.type === "BODY")?.text || "";
    return (body.match(/\{\{\d+\}\}/g) || []).length;
};

export default function WaTemplateSender({ phone, onSent }) {
    const [list, setList] = useState([]);
    const [sel, setSel] = useState("");
    const [params, setParams] = useState([]);
    const [busy, setBusy] = useState(false);

    useEffect(() => { api.get("/admin/whatsapp/templates").then((r) => setList(r.data)).catch(() => setList([])); }, []);
    const tpl = list.find((t) => `${t.name}|${t.language}` === sel);
    const n = tpl ? countVars(tpl) : 0;

    const send = async () => {
        setBusy(true);
        try {
            await api.post("/admin/whatsapp/send/template", { phone, name: tpl.name, language: tpl.language, params: params.slice(0, n) });
            toast.success("Template u dërgua");
            onSent();
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Dërgimi dështoi");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="px-3 pt-3 border-t border-slate-200 space-y-2" data-testid="wa-template-sender">
            <div className="text-[11px] text-slate-500">Kanë kaluar 24 orë nga mesazhi i fundit i klientit. Dërgoni një template të aprovuar ose përdorni "Hap në WhatsApp".</div>
            <div className="flex flex-wrap gap-2">
                <select value={sel} onChange={(e) => { setSel(e.target.value); setParams([]); }} className="input-field !w-auto flex-1" data-testid="wa-template-select">
                    <option value="">— Zgjidh template ({list.length}) —</option>
                    {list.map((t) => <option key={`${t.name}|${t.language}`} value={`${t.name}|${t.language}`}>{t.name} · {t.language}</option>)}
                </select>
                {Array.from({ length: n }).map((_, i) => (
                    <input key={i} value={params[i] || ""} onChange={(e) => { const p = [...params]; p[i] = e.target.value; setParams(p); }} placeholder={`{{${i + 1}}}`} className="input-field !w-32" />
                ))}
                <button onClick={send} disabled={!tpl || busy} className="btn-primary !py-2" data-testid="wa-template-send">Dërgo template</button>
            </div>
        </div>
    );
}
